import { axiosInstance } from '@/lib/utils';
import { endpoints } from '@/api';
import type { PickupLocation, RequestResponse } from '@/types';
import type {
  PickupLocationCreatePayload,
  PickupLocationUpdatePayload,
} from './payload';

export const createPickupLocation = async (
  payload: PickupLocationCreatePayload
) => {
  const response = await axiosInstance.post<RequestResponse<PickupLocation>>(
    endpoints.pickupLocations,
    payload
  );
  return response.data;
};

export const updatePickupLocation = async ({
  id,
  ...payload
}: PickupLocationUpdatePayload) => {
  const response = await axiosInstance.patch<RequestResponse<PickupLocation>>(
    `${endpoints.pickupLocations}/${id}`,
    payload
  );
  return response.data;
};

export const deletePickupLocation = async (id: number) => {
  const response = await axiosInstance.delete<RequestResponse<PickupLocation>>(
    `${endpoints.pickupLocations}/${id}`
  );
  return response.data;
};
